import { Component, ViewChild } from '@angular/core';
import { AlertController, LoadingController, Nav, NavController, Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { Storage } from '@ionic/storage';
import { UsuarioModel } from '../models/usuario-model';
import { GlobalServiceProvider } from '../providers/global-service';
import { LoginServiceProvider } from '../providers/login-service';
import { Headers, RequestOptions } from '@angular/http';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {

  @ViewChild(Nav) navCtrl: Nav;
  rootPage: any;
  pages: Array<{ title: string, component: any, icon: any, color: string, param: string }>;
  usuario: UsuarioModel = new UsuarioModel();
  version: string = '1.06';

  branch: string = ''

  constructor(
    public loadingCtrl: LoadingController,
    platform: Platform, statusBar: StatusBar,
    splashScreen: SplashScreen,
    public storage: Storage,
    public global: GlobalServiceProvider,
    public loginService: LoginServiceProvider,
    private alertCtrl: AlertController) {
    storage.get('accessUrl').then((value) => {

      if (value) {

        global.setAccessUrl(value);

        storage.get('accessUser').then((value) => {

          if (value) {

            global.setUserPass(value.username + ':' + value.password);
            global.setEmpresa(value.empresa + ',' + value.filial);

            if (value.login) {
              this.rootPage = 'HomePage';
              this.usuario = value;
            } else {
              this.rootPage = 'LoginPage';
            }

          } else {
            this.rootPage = 'LoginPage';
          }

        }).catch(() => this.rootPage = 'LoginPage');

      } else {
        this.rootPage = 'AcessoPage';
      }

    }).catch(() => this.rootPage = 'AcessoPage');

    platform.ready().then(() => {
      statusBar.styleDefault();
      statusBar.backgroundColorByHexString('#ffff');
      splashScreen.hide();
    });

    this.pages = [
      { title: 'Home', component: 'HomePage', icon: 'home', color: 'primary', param: '' },
      { title: 'Produção', component: 'MenuPage', icon: 'stats', color: 'primary', param: 'producao' },
      { title: 'Estoque', component: 'MenuPage', icon: 'barcode', color: 'primary', param: 'estoque' },
      { title: 'Expedição', component: 'MenuPage', icon: 'cart', color: 'primary', param: 'expedicao' },
      { title: 'Preferências', component: 'PreferenciasPage', icon: 'options', color: 'primary', param: '' },
      { title: 'Logout', component: 'LoginPage', icon: 'log-out', color: 'primary', param: '' }
    ];

  }

  openPage(page) {
    this.navCtrl.setRoot(page.component, { param: page.param });
  }

  validate(ev: any) {
    this.storage.get('accessUser').then(user => {
      if (user != null) {

        if (this.global.getEmpresa() != ev._value) {          

          let usuario = btoa(user.username + ":" + user.password);
          let headers = new Headers({ 
            "Authorization": "BASIC " + usuario, 
            "tenantId": ev._value, 
            "Access-Control-Allow-Origin": "*" 
          });
          let options = new RequestOptions({ headers: headers });

          this.global.setUserPass(user.username + ':' + user.password)

          this.storage.get('accessUrl').then(value => {

            let loading = this.loadingCtrl.create({
              content: 'Alterando empresa filial...'
            });

            loading.present()            

            this.loginService.fetchData(user.username, user.password, value, options, ev._value).then(data => {
              if (data) {

                if (data !== 'notShow') {

                  console.log(data);
                  

                  this.storage.set('accessUser', {
                    'username': user.username,
                    'password': user.password,
                    'login': true,
                    'nome': data.data.usuario_nome,
                    'email': data.data.usuario_email,
                    'cargo': data.data.usuario_cargo,
                    'empresa': this.global.getFullCompany().empresa_codigo,
                    'filial': this.global.getFullCompany().filial_codigo,
                    'nomfil': this.global.getFullCompany().filial_nome_comercial,
                    'cnpj': this.global.getFullCompany().filial_cnpj,
                    'departamento': data.data.usuario_departamento,
                    'maskSlab': (data.data.mask_slab ? data.data.mask_slab : 'TTTTLLLLLLLLSSS')
                  });
                  
                  this.global.setEmpresa(this.global.getFullCompany().empresa_codigo + ',' + this.global.getFullCompany().filial_codigo);

                  console.log(this.global.getEmpresa());

                  this.alertCtrl.create({
                    title: 'Alteração de Empresa Filial!',
                    subTitle: 'Empresa alterada com sucesso',
                    buttons: ['Fechar']
                  }).present()

                }

                if (this.storage.get('accessUser').then((value: any) => value != null)) {
                  loading.dismiss();
                }

              } else {

                let alertctrl = this.alertCtrl.create({
                  title: 'Conexão falhou!',
                  subTitle: 'Não foi possível executar a operação.',
                  buttons: ['Fechar']
                });

                this.storage.get('accessUser').then((value) => {

                  if (value == null || value == undefined || value == "") {

                    alertctrl.present();

                  } else {

                    if (value.username == user.username && value.password == user.password) {

                      this.storage.set('accessUser', { 'username': user.username, 'password': user.password, 'login': true });

                    } else {
                      alertctrl.present();
                    }
                  }
                }).catch(() => alertctrl.present())
              }
            })

            loading.dismiss();

          }).catch(() => {
            this.navCtrl.push('AcessoPage')
          });
        }
      } else {
        this.navCtrl.push('LoginPage')
      }
    }).catch(() => this.navCtrl.push('LoginPage'))
  }
}


// WEBPACK FOOTER //
// ./src/app/app.component.ts